<template>
  <b-col class="watch-list">
    <b-row v-for="stock in list"
           v-bind:key="stock.id"
           class="p-2">
      <b-col cols="1"
             class="pt-2 deselect-icon"
             v-on:click="click(stock)">
        <img src="../assets/images/portfolio-tracker/cross-icon.svg"
             alt="close icon" />
      </b-col>

      <b-col class="stock-symbol">
        <div>
          {{stock.symbol}}
          <notification-icon :stock="stock" />
        </div>
        <div>{{stock.name}}</div>
      </b-col>

      <b-col class="price-change">
        <div>{{ stock.buy | rounding(stock.currencysign) }}</div>
        <div v-bind:class="getStockChange(stock.change)">{{formatChange(stock.change) | getPercentage}}</div>
      </b-col>
    </b-row>
  </b-col>
</template>
<script>
import NotificationIcon from '@/components/NotificationIcon'
export default {
  components: {
    NotificationIcon
  },
  props: {
    list: {
      required: true
    },
    click: {
      required: true
    }
  },
  filters: {
    getPercentage: change => (change === 0 ? '0%' : `${change.toFixed(2)}%`),
    rounding: (value, currencySymbol) => (value === 0 ? '' : `${currencySymbol} ${value.toFixed(2)}`)
  },
  methods: {
    getStockChange: change => {
      if (change === 0) return 'change-even'
      return change > 0 ? 'change-up' : 'change-down'
    },
    formatChange: change => {
      return (change * 100)
    }
  }
}
</script>
<style lang="scss" scoped>
.watch-list {
  color: $color-text-grey;
  .deselect-icon {
    cursor: pointer;
  }
  .row {
    border-bottom: 1px solid $color-border-grey;
  }
  img {
    width: 1rem;
  }
  .stock-symbol {
    text-align: left;
    div {
      &:nth-child(2) {
        color: $color-text-grey;
        font-size: 0.9rem;
      }
    }
  }
  .change-even {
    color: $color-text-grey;
  }
  .change-up {
    color: green;
  }
  .change-down {
    color: red;
  }
  .price-change {
    margin: auto;
    text-align: right;
    div {
      display: inline-block;
      &:nth-child(2) {
        width: 70px;
      }
    }
  }
}
</style>
